export class PdfForm {
    id: number;
    code: string;
    title: string;
    summary: string;
    // creationDate: Date;
    // lastRevisedDate: Date;
    // editedByUserName: string;
    // authorUserName: string;
    // formGroupIds: number[];
    formGroupId:number;
    formUrl:string;
    file:any
  }
  